import widgetIsPresent from '../../utils/widgetIsPresent';
import getMyCarsVehicleFromVinOrId from '../../utils/getMyCarsVehicleFromVinOrId';
import findVehicleByProperty from '../../utils/findVehicleByProperty';
import getInventoryType from '../../utils/getInventoryType';

export const MYCARSSAVE = 'mycarsSave';
export const MYCARSGETALERTS = 'mycarsGetAlerts';
export const MYCARSCOMPARECHECK = 'mycarsCompareCheck';

/**
 * A generic function to handle very similar MyCars events
 *
 * @param $element The jquery object of the element clicked on
 * @param myCarsEvent The Mycars event to be tracked - either 'mycarsSave', 'mycarsGetAlerts', or 'mycarsCompareCheck
 * @returns null
 */
function handleMyCarsEvents(
	{
		DDC: {
			dataLayer: {
				page: {
					pageInfo: {
						isVdp = false,
						isVlp = false,
						pageWidgets,
						pageName
					}
				},
				myCars,
				vehicles
			}
		}
	},
	myCarsEvent,
	{ currentTarget: element }
) {
	const eventType = `ddc.link.${myCarsEvent}`;
	const isSRP = widgetIsPresent(/ws-inv-listing/, pageWidgets);
	const isMyCarsFavoritesPage = pageName === 'MYCARS_FAVORITES';
	const eventData = {
		element
	};
	const $element = $(element);
	let vehicle;
	let vin;
	let uuid;

	if ($element.parents('.mycars-list-row').length > 0) {
		// this indicates that we are in the MyCars navigation dropdown
		vin = $element.parents('.mycars-vehicle').data('vin');
		uuid = $element.parents('.mycars-vehicle').data('uuid');
		vehicle = getMyCarsVehicleFromVinOrId(vin, myCars);
	} else if ($element.parents('.mycars-mobile-list').length > 0) {
		// this indicates that we are in the MyCars mobile slide menu
		vin = $element.parents('.mycars-vehicle').data('vin');
		uuid = $element.parents('.mycars-vehicle').data('uuid');
		vehicle = findVehicleByProperty('vin', vin, vehicles);
	} else if (!isSRP && (isVlp || isMyCarsFavoritesPage)) {
		vin = $element.parents('.hproduct').data('vin');
		uuid = $element.parents('.hproduct').data('uuid');
		vehicle = findVehicleByProperty('vin', vin, vehicles);
	} else if (isSRP) {
		vin = $element.parents('[data-vin]').data('vin');
		uuid = $element.parents('[data-uuid]').data('uuid');
		vehicle = findVehicleByProperty('uuid', uuid, vehicles);
		eventData.isSRP = isSRP;
	} else if (isVdp) {
		[vehicle] = vehicles;
	} else {
		vehicle = {
			make: '',
			model: '',
			trim: '',
			vin: '',
			year: ''
		};
	}

	eventData.vin = vehicle.vin;
	eventData.make = vehicle.make;
	eventData.model = vehicle.model;
	eventData.trim = vehicle.trim;
	eventData.year = vehicle.year || vehicle.modelYear;
	eventData.inventoryType = getInventoryType(vehicle) || '';
	if (isVdp) {
		[eventData.vehicle] = vehicles;
	} else {
		const vehicleByUuid = findVehicleByProperty('uuid', uuid, vehicles);
		if (Object.keys(vehicleByUuid).length) {
			eventData.vehicle = vehicleByUuid;
		} else {
			eventData.vehicle = findVehicleByProperty('vin', vin, vehicles);
		}
	}

	return {
		eventType,
		eventData
	};
}

export default handleMyCarsEvents;
